<section>
    <xm-modal-close xmEscKey (escKeyPressed)="close()" (onClose)="close()"></xm-modal-close>
    <xm-carousel *ngIf="announcementArray.length > 1; else singleSlide" [ngClass]="{'dismiss-btn': !isDismissable}"
        [upperSettings]="carousalSettings" [slideData]="announcementArray"
        (activeSlideIndex)="announcementSeen($event)">
        <div class="swiper-slide" *ngFor="let announcement of announcementArray" upper>
            <xm-media-image aria-hidden="true" class="icon" [imageOptions]="icon" size="height"></xm-media-image>
            <h2 mat-dialog-title id="header">{{ announcement.content.header }}</h2>
            <p class="sub-header">{{ announcement.content.subHeader }}</p>
            <cms-text class="disclaimer" [originalText]="announcement.content.disclaimer"></cms-text>
            <div class="do-not-show" *ngIf= "!announcement.alwaysShow">
                <input id="{{'do-not-show' + announcement.announcmentId}}" class="checkbox" type="checkbox" [checked]="announcement.doNotShow" (change)="toggleDoNotShow(announcement)"/>
                <label for="{{'do-not-show' + announcement.announcmentId}}" class="label">
                    <xm-checkbox [isSelected]="announcement.doNotShow"></xm-checkbox>
                    <p class="content">{{ pageData.doNotShowText }}</p>
                </label>
            </div>
        </div>
    </xm-carousel>
    <ng-template #singleSlide>
        <xm-media-image aria-hidden="true" class="icon" [imageOptions]="icon" size="height"></xm-media-image>
        <h2 mat-dialog-title id="header">{{ announcementArray[0].content.header }}</h2>
        <p class="sub-header">{{ announcementArray[0].content.subHeader }}</p>
        <cms-text class="disclaimer" [originalText]="announcementArray[0].content.disclaimer"></cms-text>
        <div class="do-not-show" *ngIf= "!announcementArray[0].alwaysShow">
            <input name="do-not-show" id="do-not-show" class="checkbox" type="checkbox" [checked]="announcementArray[0].doNotShow" (change)="toggleDoNotShow(announcementArray[0])"/>
            <label for="do-not-show" class="label">
                <xm-checkbox [isSelected]="announcementArray[0].doNotShow"></xm-checkbox>
                <p class="content">{{ pageData.doNotShowText }}</p>
            </label>
        </div>
    </ng-template>
    <button class="xm-btn-primary-dark" *ngIf="isDismissable" (click)="close()">{{ pageData.primaryBtn }}</button>
</section>
